import api from './api';
import type { HrDashboardResponse } from '../types/hr-dashboard.types';

export interface HrExportCheckParams {
  view: string;
  format: 'csv' | 'xlsx';
  filters?: string;
}

export const hrDashboardApi = {
  get: (refresh = false) =>
    api.get<HrDashboardResponse>(`/api/hr/dashboard${refresh ? '?refresh=true' : ''}`),

  checkExport: ({ view, format, filters }: HrExportCheckParams) => {
    const params = new URLSearchParams({ view, format });
    if (filters) params.set('filters', filters);
    return api.get<{ success: boolean }>(`/api/hr/dashboard/export-check?${params.toString()}`);
  },
};
